import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-s mt-s justify-between lg:flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Abrechnungen", -1)
const _hoisted_3 = { class: "w-full lg:w-1/2" }
const _hoisted_4 = { key: 0 }

import { computed, ref } from "vue";

import EmptyContainer from "@/components/EmptyContainer.vue";
import { useOrdersStore } from "@/store/ordersStore";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import RoundedCard from "@/components/RoundedCard.vue";
import { CareProviderGroup } from "@/interfaces/careProviderGroup";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";

export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersInvoiceView',
  setup(__props) {

const senderModel = ref<CareProviderGroup | undefined>(undefined);
const ordersStore = useOrdersStore();
const managedPatientsStore = useManagedPatientsStore();

const ordersOfCareProviderGroupByPatient = computed(() => {
  let ordersByPatient = new Map<number, Map<string | number, number>>();
  let orders = ordersStore.messages;
  let conversations = ordersStore.conversations;
  if (!conversations || !orders) return ordersByPatient;
  let sentDatesOfConversations = new Map<number, Date>();
  for (const conversation of conversations.entries()) {
    if (conversation[1].senderCareProviderGroup.id != senderModel.value?.id)
      continue;
    if (conversation[1].orders_sent?.created_at) {
      sentDatesOfConversations.set(
        conversation[0],
        new Date(conversation[1].orders_sent?.created_at)
      );
    }
  }

  for (const order of orders) {
    const medicationOrder = order[1].medication_order;
    if (!medicationOrder) continue;
    const gtin = /*medicationOrder.gtin*/ 0; // force name
    const id = gtin != 0 ? gtin : medicationOrder.name;

    const sent = sentDatesOfConversations.get(order[1].conversation.id);
    if (sent == undefined) continue;
    const patientId = medicationOrder.patient_id;
    if (!ordersByPatient.get(patientId)) {
      ordersByPatient.set(patientId, new Map());
    }

    ordersByPatient
      .get(patientId)
      ?.set(
        id,
        (ordersByPatient.get(patientId)?.get(id) ?? 0) + medicationOrder.amount
      );
  }
  ordersByPatient = new Map([...ordersByPatient.entries()].sort());

  return ordersByPatient;
});

function managedPatientById(id: number): string {
  if (id === 0) {
    return "Verbrauchsmaterial";
  }
  let array = Array.from(managedPatientsStore.patients?.values() ?? []);
  let patient = array.find((patient) => patient.id == id);
  if (!patient || !patient.currentProfile) return "";

  return `${patient.currentProfile.firstName} ${patient.currentProfile.lastName} ${patient.currentProfile.birthday}`;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(UmanaHeadline, {
        h: "h1",
        class: ""
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FormKit, {
          type: "multiselect",
          "select-options": Array.from(_unref(ordersStore).allReceivers.values()),
          loading: true,
          class: "w-full",
          "track-by": "id",
          "option-label": "group_name",
          modelValue: senderModel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((senderModel).value = $event)),
          "allow-empty": false,
          placeholder: "Unternehmen wählen"
        }, null, 8, ["select-options", "modelValue"])
      ])
    ]),
    (senderModel.value?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(RoundedCard, { color: "white" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ordersOfCareProviderGroupByPatient.value, (patient) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: patient[0]
                  }, [
                    _createTextVNode(_toDisplayString(managedPatientById(patient[0])) + " ", 1),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patient[1], (order) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: order[0]
                        }, " -- " + _toDisplayString(order[1]) + "x " + _toDisplayString(order[0]), 1))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(EmptyContainer, { key: 1 }, {
          default: _withCtx(() => [
            _createTextVNode(" Kein Unternehmen ausgewählt ")
          ]),
          _: 1
        }))
  ], 64))
}
}

})